module.exports = __webpack_public_path__ + "static/media/Fog.ad8db6b2.svg";